module.exports = __webpack_public_path__ + "static/media/bpo2.4a2dda97.jpg";